
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import { CaseArea, Area, TreeNode } from "@/types"

@Component({
	components: {
		tree: () => import("./AreaTree.vue")
	}
})
export default class AreaTree extends Vue {
	@Prop()
	area!: TreeNode<Area>;

	@Prop()
	activeAreaId!: string;

	@Prop()
	selectedAreas!: CaseArea[];

	@Prop()
	setActiveArea!: (areaId: string) => void;

	@Prop()
	addArea!: (area: Area) => void;
}
